<template>
  <div>
    <AppNewHeader
      style="width: 100%"
      @custom-event="handleEvent"
      :userName="userName"
      :placeholderText="'搜索知识资源'"
    />
    <ArawerCard></ArawerCard>

    <div class="carousel-container">
      <!-- <el-carousel
        class="carousel"
        height="380px"
        :autoplay="true"
        ref="carouselRef"
        @change="handleCarouselChange"
      >
      
             <el-carousel-item class="index_banner" @click="handleinfogo('4affb95f-ec8a-4c71-a3b2-f53ed4db5f03')">
          <img :src="carouselItems[3]" class="carousel-image" />
          <div class="carousel-text carousel-text-center">
           
          </div>
        </el-carousel-item>
             <el-carousel-item class="index_banner"  @click="handleinfogo('c87fe5c1-ffc6-447e-aa35-484909d73b3a')">
          <img :src="carouselItems[4]" class="carousel-image" />
          <div class="carousel-text carousel-text-center">
         
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img :src="carouselItems[2]" class="carousel-image" />
          <div class="carousel-text carousel-text-center">
            <div class="text-content" style="color: rgba(66, 66, 66, 1)">
              <div>
                知识库
                <span class="highlight-text">专业权威 正规出版 内容优质</span>
              </div>
              <div>提供一站式灵活组配选购</div>
            </div>
          </div>
        </el-carousel-item>

        <el-carousel-item>
          <img :src="carouselItems[1]" class="carousel-image" />
          <div class="carousel-text carousel-text-center">
            <div class="text-content">
              <div>
                运营全过程<span class="highlight-text" style="color: #44e3f5"
                  >公开透明</span
                >
              </div>
              <div>
                盘活出版商<span class="highlight-text" style="color: #44e3f5"
                  >优质资源</span
                >
              </div>
            </div>
          </div>
        </el-carousel-item>

        <el-carousel-item>
          <img :src="carouselItems[0]" class="carousel-image" />
          <div class="carousel-text carousel-text-center">
            <div class="text-content">
              <div style="margin-right: 477px">
                国家出版知识
                <span class="highlight-text" style="color: #44e3f5"
                  >资源平台</span
                >
              </div>
              <div style="padding-right: 329px">
                打通知识服务
                <span class="highlight-text" style="color: #44e3f5">上下游</span
                ><span class="highlight-text"></span>
              </div>
            </div>
          </div>
        </el-carousel-item>
     
      </el-carousel> -->
     <NewBannerindex/>
    </div>
    <div class="SpecializedBook">
      <div class="Speciacont" v-loading="loading">
        <div class="leftcont">
          <div class="lefttitle">
            <!-- <div class="zticon">
              <el-icon><Tickets /></el-icon>
            </div> -->
            <div class="ztk_text">专题数字图书馆</div>
            <Accordion class="three__box__text" :list="dataOpenList">
              <!-- <template #item__content0>
        <div class="edu__gaikuang">11</div>
      </template>
      <template #item__content1>
        <div class="edu__gongbao">22</div>
      </template>
      <template #item__content2>
        <div class="edu_nianjian">33</div>
      </template> -->
            </Accordion>
          </div>
        </div>
        <div class="rightcont">
          <div class="righttitle">
            <!-- <div class="zxsjicon">
              <el-icon><Tickets /></el-icon>
            </div> -->
            <div class="zxsjtext">最新上线</div>
          </div>
          <div class="newlist">
            <div
              class="newlistitem"
              v-for="(item, index) in NewKnowledgeBaseList"
              :key="index"
              v-show="index < 9"
            >
              <div>
                <div class="list1">
                  <p
                    :title="item?.title"
                    class="list1title"
                    @click="datebaseinfo(item)"
                  >
                    {{ item?.title }}
                  </p>
                  <div class="iconlist3">
                    <div class="iconitem3">
                      <CustomPopover placement="bottom">
                        <template #trigger>
                          <!-- <div class="intro-btn">
                            <img :src="jjicon" alt="简介" />
                            <span class="jianjie_jianjie">简介</span>
                          </div> -->
                        </template>
                        <template #content>
                          <div class="popover-desc">
                            <p
                              style="
                                font-size: 14px;
                                color: #333;
                                font-weight: bold;
                                margin-bottom: 20px;
                              "
                            >
                              {{ item?.title }}
                            </p>
                            <p v-html="item?.description || '暂无简介'"></p>
                          </div>
                        </template>
                      </CustomPopover>
                    </div>
                  </div>
                  <p class="listtime">{{ getYearMonth(item?.createTime) }}</p>
                </div>
              </div>
              <!-- <div class="cardicon">
                <img
                  :src="cardicon"
                  @click="triggerParentEvent(item, $event)"
                  alt=""
                />
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
   <div class="new_jpzskbox" v-loading='loading'>
     <div class="jpzsk_left" :style="{ width: leftWidth + 'px' }">
      <div class="jpzsk_left_content">
           <div class="jpzskheader">
            <div class="jpzsktitle">
              <p>精品知识库</p>
            </div>
            <div class="jpzsktab">
              <div
                class="jpzsktabitem"
                v-for="(item, index) in tablist"
                :key="index"
                @click="selectTab(item)"
                :class="{ active: tabactiveIndex === item.cid }"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
               <el-carousel
            height="280px"
            indicator-position="outside"
            :autoplay="false"
            arrow="always"
            @change="handleChange"
            ref="carousel"
            trigger="click"
          >
            <el-carousel-item v-for="(item, index) in imgList" :key="index">
              <div class="jpzskimg_text">
                <div class="jpzskimg">
                  <img
                    style="width: 100%; height: 100%"
                    :src="getImagePath2(item?.imgUrl)"
                    loading="lazy"
                    alt=""
                  />
                </div>
                <div class="jpzsktext">
                  <div class="texttitle">
                    <p @click.stop="datebaseinfo(currentItem)">
                      {{ currentItem?.title || "中国共产党思想理论资源数据库" }}
                    </p>
                  </div>
                  <div class="jpzsktextcont">
                 
                      <el-scrollbar height="120px">
                        <p
                      v-html="
                        currentItem?.description ||
                        '暂无简介'
                      "
                    ></p>
                     </el-scrollbar>
                  </div>
                  <div class="iconlist4">
                    <div class="iconitem4">
                      <div class="wlfw_icon">
                        <img :src="wlfw" alt="" />
                        <p>网络访问 | 镜像访问</p>
                      </div>
                      <div class="intro-btn" @click="handlejpzskinffo">
                        <img :src="jjicon" alt="简介" />
                        <span class="jianjie_jianjie">简介</span>
                      </div>
                    </div>
                  </div>

                  <div class="jpzskbut">
                    <div class="ckxqbut" @click="datebaseinfo(currentItem)">
                      查看详情
                    </div>
                    <div
                      class="addcard"
                      @click="triggerParentEvent(currentItem, $event)"
                    >
                      加入采购清单
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
                 <transition name="fade">
            <div
              v-if="jzzsktype"
              class="overlay"
              @click="handlejpzskinffo"
            ></div>
          </transition>

          <transition name="popover">
            <div class="zpzsk_Popover" v-if="jzzsktype">
              <p class="jpzsk_title">{{ currentItem?.title }}</p>
              <p class="jpzsk_content" v-html="currentItem?.description || '暂无简介' "></p>
            </div>
          </transition>
      </div>


     </div>
     <div class="jpzsk_right" :style="{ width: rightWidth + 'px' }" v-loading='loading'>

        <div class="jpzsk_right_content">
          <div class="zskbdtitle" style="display: flex;justify-content: space-between;">
            <p>知识库榜单</p>
            <p style="font-size: 14px;padding-top: 28px;">访问量</p>
          </div>
          <div class="zskbdlist">
            <div
              class="zskbditem"
              v-for="(item, index) in BuyKnowledgeBaseList"
              :key="index"
              v-show="index < 6"
            >
            <div @click="datebaseinfo(item)" class="zskbditem1" style="  display: flex; align-items: center;gap: 10px;">  <img :src="getNumberIcon(index)" class="number-icon" />
              {{ item?.title }}</div>


              <div style="font-size: 12px;font-weight: 400;  color: rgba(255, 255, 255, 0.8);"> <p>  {{ item?.useCount }}</p> </div>
            </div>
          </div>
      </div>

     </div>


   </div>


    <div class="zsknavcont">
      <div class="zskfllist">
        <div class="zskfl_header">
          <!-- <p class="class="zskfltitle"">知识库分类</p> -->
          <div class="zskfltitle"><p>知识库分类</p></div>
          <div class="zskfl_more" @click="handleMore"><p>查看更多 ></p></div>
        </div>
        <div class="zskflnavlist">
          <div class="zskflnalvlist">
            <!-- <div class="headerbox">
              <p class="navtitle1">{{ navtotalname }}</p>
              <p class="sqlnumber">收录数据库 {{ totalnumber }}个</p>
            </div> -->
            <div
              class="navlistitem"
              v-for="(item, index) in navlists"
              :key="index"
              @click="handlenavinfo(item, index)"
              :class="{ active: activeNavIndex5 === index }"
            >
              <!-- <p> -->
              {{ item.name }}
              <p class="sqlnumber">收录数据库 {{ totalnumber }}个</p>
              <!-- </p> -->
            </div>
          </div>
          <div class="zskflrightcont" v-loading="loading">
            <div
              class="zsknavrightbanner"
              :style="{
                backgroundImage: `url('${getImagePath3(navindeximg)}')`,
                backgroundSize: 'cover',
              }"
            >
              <div class="righthedder">
                <p class="zsknavrighttitle">{{ navtotalname }}</p>
              </div>
              <!-- <div class="lookmorenew" @click="handleMore">查看更多</div> -->
            </div>
            <div class="nav_textlist">
         <div class="navbottext">
                <div class="botleft">
                  <div  class="title_hot"  @click="datebaseinfo(tabactiveIndex1)">
                    <p>{{ tabactiveIndex1?.title }}</p>
                      <div class="hotclass">Hot</div>
                  </div>
                  <div style="display: flex;padding: 0px 10px 20px 20px;">
                    <div class="botimg">
                      <img
                        :src="getImagePath2(tabactiveIndex1?.imgUrl || '')"
                        alt=""
                        loading="lazy"
                      />
                    </div>
                    <div class="botimg_text">
                      <!-- <div
                        class="title_hot"
                        @click="datebaseinfo(tabactiveIndex1)"
                      >
                        <p>{{ tabactiveIndex1?.title }}</p>
                        <div class="hotclass">Hot</div>
                      </div> -->
                      <div class="bottextcont">
                        <el-scrollbar>
                        <p>
                        <span>简介：</span>
                        <span  >{{ tabactiveIndex1.descroptionHtml?tabactiveIndex1.descroptionHtml.replaceAll("<p>","").replaceAll("</p>",""):'' }}</span>
                        </p>
                      </el-scrollbar>
                       
                      </div>
                      <div class="iconlist6">
                        <div class="iconitem6">
                          <img :src="wlfw" alt="" />
                          <p>网络访问 | 镜像访问</p>
                        </div>
                        <div class="iconitem6">
                          <CustomPopover placement="bottom">
                            <template #trigger>
                              <div class="intro-btn">
                                <img :src="jjicon" alt="简介" />
                                <span class="jianjie_jianjie">简介</span>
                              </div>
                            </template>
                            <template #content>
                              <div class="popover-desc">
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #333;
                                    font-weight: bold;
                                    margin-bottom: 20px;
                                  "
                                >
                                  {{ tabactiveIndex1?.title }}
                                </p>
                                <p
                                  v-html="
                                    tabactiveIndex1?.description || '暂无简介'
                                  "
                                ></p>
                              </div>
                            </template>
                          </CustomPopover>
                        </div>
                        <div data-v-79d11e06="" class="addcard" @click="triggerParentEvent(tabactiveIndex1, $event)"> 加入采购清单 </div>
                      </div>
                      <!-- <div class="zhankai">展开简介</div> -->
                    </div>
                  </div>
                  
                </div>
                <!-- <div
                  class="jiaruqd"
                  @click="triggerParentEvent(tabactiveIndex1, $event)"
                >
                  加入采购清单
                </div> -->
                <div class="botleft">
                  <div class="title_hot" @click="datebaseinfo(tabactiveIndex2)">
                    <p>{{ tabactiveIndex2?.title }}</p>
                    <div class="hotclass">Hot</div>
                  </div>
                  <div style="display: flex;padding:0px 10px 20px 20px;">
                    <div class="botimg">
                      <img
                        :src="getImagePath2(tabactiveIndex2?.imgUrl || '')"
                        alt=""
                      loading="lazy"
                      />
                    </div>
                    <div class="botimg_text">
                      <!-- <div
                        class="title_hot"
                        @click="datebaseinfo(tabactiveIndex2)"
                      >
                        <p>{{ tabactiveIndex2?.title }}</p>
                        <div class="hotclass">Hot</div>
                      </div> -->
                      <div class="bottextcont" style="display: flex;">
                         <el-scrollbar>
                           <p >
                          <span>简介：</span>
                          <span  >{{ tabactiveIndex2.descroptionHtml?tabactiveIndex2.descroptionHtml.replaceAll("<p>","").replaceAll("</p>",""):'' }}</span>
                          </p>
                        </el-scrollbar>
                      </div>
                      <div class="iconlist6">
                        <div class="iconitem6">
                          <img :src="wlfw" alt="" />
                          <p>网络访问 | 镜像访问</p>
                        </div>
                        <div class="iconitem6">
                          <CustomPopover placement="bottom">
                            <template #trigger>
                              <div class="intro-btn">
                                <img :src="jjicon" alt="简介" />
                                <span class="jianjie_jianjie">简介</span>
                              </div>
                            </template>
                            <template #content>
                              <div class="popover-desc">
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #333;
                                    font-weight: bold;
                                    margin-bottom: 20px;
                                  "
                                >
                                  {{ tabactiveIndex2?.title }}
                                </p>
                                <p
                                  v-html="
                                    tabactiveIndex2?.description || '暂无简介'
                                  "
                                ></p>
                              </div>
                            </template>
                          </CustomPopover>
                        </div>
                        <div data-v-79d11e06="" class="addcard" @click="triggerParentEvent(tabactiveIndex2, $event)"> 加入采购清单 </div>
                      </div>
                      <!-- <div class="zhankai">展开简介</div> -->
                    </div>
                  </div>
                  
                </div>
                <!-- <div
                  class="jiaruqd"
                  @click="triggerParentEvent(tabactiveIndex2, $event)"
                >
                  加入采购清单
                </div> -->
              </div>
              <div class="rightList">
                <div class="newlist2">
                  <div
                    class="newlistitem2"
                    v-for="(item, index) in activeNav3"
                    :key="index"
                    v-show="index < 8"
                  >
                    <div style="width: 333px;padding-top: 10px;">
                      <div class="list8">
                        <p class="list1title8" @click.stop="datebaseinfo(item)">
                          {{ item?.title }}
                        </p>
                        <!-- <p class="listtime8">{{ getYearMonth(item.createTime) }}</p> -->
                      </div>
                      <div class="iconlist8" style="margin-top: 5px;">
                        <div class="iconitem8" style="width: 105px;">
                          <img :src="wlfw" alt="" />
                          <p>网络访问 | 镜像访问</p>
                        </div>
                        <div class="iconitem8">
                          <CustomPopover placement="bottom">
                            <template #trigger>
                              <div class="intro-btn">
                                <img :src="jjicon" alt="简介" />
                                <span class="jianjie_jianjie">简介</span>
                              </div>
                            </template>
                            <template #content>
                              <div class="popover-desc">
                                <p
                                  style="
                                    font-size: 14px;
                                    color: #333;
                                    font-weight: bold;
                                    margin-bottom: 20px;
                                  "
                                >
                                  {{ item?.title }}
                                </p>
                                <p v-html="item?.description || '暂无简介'"></p>
                              </div>
                            </template>
                          </CustomPopover>
                        </div>
                      </div>
                    </div>
                    <div class="cardicon8">
                      <img
                        :src="cardicon"
                        @click.stop="triggerParentEvent(item, $event)"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="citysql">
      地方特色数据库
      <img class="sjx" :src="sjx" alt="" />
      <!-- <div class="circle2"></div> -->
    </div>
    <!-- 地方特色数据库 -->
    <div class="LocalBox">
      <div class="LocalBox_content">
        <AppLocalChara
          :items="provinces"
          :province="province"
          item-width="100"
          visible-items="4"
          @item-selected="handleSelect"
        />
      </div>
    </div>
    <div class="yylycont" v-loading="loading">
      <div class="yyly_content">
        <div class="yylyheader">
          <div class="yylytitle">应用领域</div>
          <div class="yylytab_more">
            <div class="yylutab">
              <div
                class="yylutabitem"
                v-for="(item, index) in yylutablist"
                :key="index"
                @click="handleyylyTab(item, index)"
                :class="{ active: yylytabactiveIndex === index }"
              >
                {{ item }}
              </div>
            </div>
            <div class="yylymore" @click="gotoList">查看更多></div>
          </div>
        </div>
        <div class="yyly_img_center_list">
          <div
            class="yyly_img"
            :style="{
              backgroundImage: `url(${tabImages[yylytabactiveIndex]})`,
            }"
          >
            <div class="yyly_text_title">
              <p>{{ yylyName }}</p>
            </div>
            <div class="yylycont_text">
              <p v-html="yylytextcont">
                
              </p>
            </div>
          </div>
          <div class="yyly_list">
            <div class="yylyright_img_">
              <div class="img_title">{{ yylyimg_text?.title }}</div>
              <div class="img_item">
                <img  loading="lazy" :src="getImagePath2(yylyimg_text?.imgUrl)" alt="" />
              </div>
              <div class="img_text">
             
                  <el-scrollbar  ref="myScrollbar">
                      <p v-html="yylyimg_text.description || '暂无简介' "></p>
                  </el-scrollbar>
              </div>
              <div class="img_but">
                <div class="lookimginfo" @click="datebaseinfo(yylyimg_text)">
                  查看详情
                </div>
                <div
                  class="addimgcard"
                  @click="triggerParentEvent(yylyimg_text, $event)"
                >
                  加入采购清单
                </div>
              </div>
            </div>
            <div class="yylyrightlist">
              <div
                class="yylyrightlistitem"
                v-for="(item, index) in yylyknowdelgelist"
                :key="index"
                v-show="index < 5"
                @click="handleyyluinfo(index, item)"
                :class="{ 'active-item': yyluactiveIndex === item.id }"
              >
                <div class="yyly_item_title">
                  <p :title="item?.title">{{ item.title }}</p>
                </div>
                <div class="yyly_list_icon">
                  <div class="yylywlfw">
                    <img :src="wlfw" alt="" />
                    <div class="yyly_wlfw_item">网络访问|镜像访问</div>
                  </div>
                  <div class="yylyjianjie">
                    <CustomPopover placement="bottom">
                      <template #trigger>
                        <div class="intro-btn">
                          <img :src="jjicon" alt="简介" />
                          <span class="jianjie_jianjie">简介</span>
                        </div>
                      </template>
                      <template #content>
                        <div class="popover-desc">
                          <p
                            style="
                              font-size: 18px;
                              color: #333;
                              font-weight: bold;
                              margin-bottom: 20px;
                            "
                          >
                            {{ item?.title }}
                          </p>
                          <p v-html="item?.description || '暂无简介'"></p>
                        </div>
                      </template>
                    </CustomPopover>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hydtbox">
      <div v-loading="loading">
        <div class="hydt_div">
          <div class="hydt_tetxt_title">动态要闻</div>
          <p class="hydt_ckgd" @click="handlehydtinfo">查看更多></p>
        </div>

        <div class="hydt_content">
          <div class="htdt_list" v-for="(item, index) in hydtList"  v-show="index < 4" :key="index">
            <div class="hydt_img">
              <img
                :src="getImagePath(item?.imgUrl)"
                alt=""
                @click="hydtJump(item.href)"
                loading="lazy"
             
              />
            </div>
            <div class="hydt_title">
              <p @click="hydtJump(item.href)">{{ item?.noticeTitle }}</p>
            </div>
            <div class="hydt_cont_text">
              <p>{{ item?.description || '暂无简介' }}</p>
            </div>

            <div class="hydt_but">
              <div class="hydt_titme">{{ item.createTime.split(" ")[0] }}</div>
              <div class="hydt_info" @click="hydtJump(item.href)">
                查看详情>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hzjg_box">
      <div class="hzjg_content" v-loading="loading">
        <div class="hzjg_title_tab">
          <p>合作机构</p>
          <div class="hzjg_tab_list">
            <div
              class="hzjg_tabitem"
              v-for="(item, index) in tabItems"
              :key="index"
              :class="{ active: selectedIndex === index }"
              @click="handlehzjginfo(index)"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="hzjg_img_list">
          <div
            class="hzjg_item_img"
            v-for="(item, index) in hzjgdatalist"
            :key="index"
          >
            <img loading="lazy" :src="getImagePath2(item?.logo)" alt="" />
          </div>
        </div>
      </div>
    </div>
    <AppFooter />
  </div>
</template>

<script setup>
import defaultImg from "@/assets/headerimage/矩形 2@2x.png";
import { onMounted, ref, computed, onUnmounted, reactive, onBeforeUnmount,nextTick } from "vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import AppLocalChara from "@/views/components/AppLocalChara.vue";
import AppFooter from "@/views/components/AppFooter.vue";
import ArawerCard from "@/views/components/ArawerCard.vue";
import Accordion from "@/views/components/accordion.vue";
import NewBannerindex from "@/views/components/NewBannerindex.vue";
import bus from "@/mitt/bus.js";
import { ClickOutside as vClickOutside } from "element-plus";
import {
  getLibraryKnowledgeBaseList,
  getNewKnowledgeBaseList,
  getBuyKnowledgeBaseList,
  PostKnowledgeAreaList,
  fetchResourceNavi,
  PostselectKnowledgeBaseList,
  PostJPknowList,
  getselectNotice,
  getselectPartner,
  PostProvince,
  getBuyLog,
  getselectIndexKnowledgeUp,
  getselectIndexKnowledgeDown
} from "@/api/index.js";
import wlfw from "@/assets/newimages/wlfw.png";
import jjicon from "@/assets/newimages/jjicon.png";
import sjx from "@/assets/image/三角形@2x.png";
import cardicon from "@/assets/newimages/cardicon.png";
import ggtsgimg from "@/assets/newimages/ggtsgimg.png";
import gxtsgimg from "@/assets/newimages/gxtsgimg.png";
import zfbmimg from "@/assets/newimages/zfbmimg.png";
import kydwimg from "@/assets/newimages/kydwimg.png";
import bd01 from "@/assets/newimages/bd01.png";
import bd02 from "@/assets/newimages/bd02.png";
import bd03 from "@/assets/newimages/bd03.png";
import bd04 from "@/assets/newimages/bd04.png";
import bd05 from "@/assets/newimages/bd05.png";
import bd06 from "@/assets/newimages/bd06.png";
import bd07 from "@/assets/newimages/bd07.png";
import banner1 from "@/assets/image/banner02.png";
import banner2 from "@/assets/image/banner03.png";
import banner3 from "@/assets/image/banner3.png";
// import banner4 from "@/assets/image/banner4.png";
import banner5 from "@/assets/image/banner5.png";
import { Tickets } from "@element-plus/icons-vue";
import { Cookie } from "@/utils/Cookie";

import CustomPopover from "@/views/components/CustomPopover.vue";
import { useRouter } from "vue-router";
import { usePageStayTime } from "@/utils/usePageStayTime";
const { stayTime, totalStayTimes } = usePageStayTime();
const speeds = [40, 70, 40];
const tabImages = [zfbmimg, kydwimg, ggtsgimg, gxtsgimg];
const navtabImages = [zfbmimg, kydwimg, ggtsgimg, gxtsgimg];
const router = useRouter();
const LoginType = ref(false);
const LoginType1 = ref(false);
const activeNavIndex5 = ref(0);
const yylyName = ref("政府部门");
const yylytabactiveIndex = ref(0);
const navtabactiveIndex = ref(0);
const yyluactiveIndex = ref(0);
const userName = ref("");
const yylytextcont = ref("");
const yylytid = ref("");
const yylyname = ref("");
const LibraryKnowledList = ref(null);
const navtotalname = ref("水利水电");
const totalnumber = ref("");
const navindeximg = ref(
  "/profile/knowledge/image/2025/06/20/Group 2_20250620135110A008.png"
);
const activeNav3 = ref(null);
const activeNav4 = ref(null);
const activeNav5 = ref(null);
const activeNav6 = ref(null);
const selectedNavKey = ref(Number);
const NewKnowledgeBaseList = ref([]);
const currentCarouselIndex = ref(0);
const BuyKnowledgeBaseList = ref([]);
const provinces = ref([]);
const province = ref([]);
const tabactiveIndex = ref('387');
const selectedIndex = ref(0);
const tabactiveIndex1 = ref([]);
const tabactiveIndex2 = ref([]);
const imgList = ref([]);
const hydtList = ref([]);
const hzjgdatalist = ref([]);
const yylyListdata = ref([]);
const yylyknowdelgelist = ref([]);
const fristzttsgdata = ref([]);
const lableBtnRef = ref(null);
const yylyimg_text = ref([]);
const loading = ref(true);
const loading2 = ref(true);
const loading3 = ref(true);
const loading4 = ref(false);
const loading5 = ref(false);
const jzzsktype = ref(false);
const loading6 = ref(false);
const yylutablist = ref(["政府部门", "科研单位", "公共图书馆", "高校图书馆"]);
const tabItems = ref(["图书馆"]);
let autoSwitchTimer = null;
const scrollbarWidth = ref(0);
const dataOpenList = ref([]);
const hiddenTime = ref(Number);
const weburl = ref(window.location.href);
const leftWidth = ref(0)
const rightWidth = ref(0)
const screenWidth = ref(0)
// const sidePadding = ref(0)
const myScrollbar = ref(null);

const handleinfogo = (id) =>{
    localStorage.setItem("lastSelectTime", Date.now().toString());
  router.push({
    name: "newDatabaseInfo",
    query: { id: id },
  });
}


window.addEventListener("load", async () => {
  // console.log('页面被刷新了',timestamp.value);
  const stored = localStorage.getItem("lastSelectTime");
  // console.log('当前时间戳：',Date.now());
  // const timestamp2 = ref(Number(sessionStorage.getItem('timestamp')))
  hiddenTime.value = Math.floor((Date.now() - stored) / 1000);
  try {
    const res = await getBuyLog({
      type: "1",
      url: weburl.value,
      second: hiddenTime.value,
    });
    if (res.status == 200) {
      localStorage.setItem("lastSelectTime", Date.now().toString());
    }
  } catch (error) {
    console.log(error);
  }
});
const handlejpzskinffo = () => {
  jzzsktype.value = !jzzsktype.value;

  // 禁止/恢复滚动
  if (jzzsktype.value) {
    document.body.style.overflow = "hidden";
      document.body.style.paddingRight = `${15}px`;
  } else {
    document.body.style.overflow = "";
     document.body.style.paddingRight = `${0}px`;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false;
  } catch (e) {
    return true;
  }
};
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || null;
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
    if (user) {
      LoginType.value = true;
      if (user.userType === "manage") {
        LoginType1.value = false;
      } else if (user.userType === "normal") {
        LoginType1.value = true;
      }
      userName.value = user?.realName || "";
    } else {
      LoginType.value = false;
      console.log(LoginType.value, "token无效");
      userName.value = "";
      // Cookie.remove("userInfo");
      // Cookie.remove("token");
       Cookie.remove("checkIP_login");
    }

  } else {
    LoginType.value = false;
    userName.value = "";
  }
};

const hydtJump = (href) => {
  if (href) {
    window.open(href, "_blank");
  }
};

const handleyyluinfo = async( index,item) => {
  yylyimg_text.value = item;  
  yyluactiveIndex.value = item.id;
  yylyimg_text.value = {
    title: item.title,
    imgUrl: item.imgUrl,
    description: item.description || '暂无简介' ,
    id: item.id,
  };
  // 点击时重置自动切换计时器
  if (autoSwitchTimer) clearInterval(autoSwitchTimer);
  nextTick(()=>{
myScrollbar.value.update();
  })

   await nextTick()
  if (myScrollbar.value) {
    myScrollbar.value.setScrollTop(0) 
  }
  
  // startAutoSwitch();
};

const triggerParentEvent = async (card, event) => {
  bus.emit("sendMsg", {
    message: "Hello from SenderComponent!",
    card,
    event,
    lableBtn: lableBtnRef.value,
  });
};

const gotoList = () => {
  localStorage.setItem("lastSelectTime", Date.now().toString());
  router.push({
    path: "NewLicationArea",
    query: { id2: yylytid.value },
  });
};
const handlehydtinfo = () => {
  router.push({
    path: "hydtinfolist",
    // query: { id2: yylytid.value, name: yylyname.value },
  });
};

const datebaseinfo = (data) => {
  // console.log(data,'lll');
  
  localStorage.setItem("lastSelectTime", Date.now().toString());
  router.push({
    name: "newDatabaseInfo",
    query: { id: data.id },
  });
};
const handlehzjginfo = async (index) => {
  selectedIndex.value = index;
  if (index == 0) {
    await gethzjgList("图书馆");
  } else if (index == 1) {
    await gethzjgList("出版社");
  } else if (index == 2) {
    await gethzjgList("高校");
  }
};

const gethzjgList = async (name) => {
  const res = await getselectPartner({
    remark: name,
  });
  if (res.info) {
    hzjgdatalist.value = res.info;
    loading6.value = false;
  }
};

const handleyylyTab = (item, index) => {
  yylytabactiveIndex.value = index;
    yyluactiveIndex.value = 0


  if (index == 0) {
    yylyName.value = "政府部门";
    yylytextcont.value = yylyListdata.value[0].description || '暂无简介' ;
    yylyknowdelgelist.value = yylyListdata.value[0].knowledges;
    yylyimg_text.value = yylyListdata.value[0].knowledges[0];
    // yylyimg_text.value = yylyListdata.value[0]
    // console.log( yylyListdata.value);
    yylytid.value = yylyListdata.value[0].id;
    yylyname.value = yylyListdata.value[0].name;
  } else if (index == 1) {
    yylyName.value = "科研单位";
    yylytextcont.value = yylyListdata.value[1].description || '暂无简介';
    yylytid.value = yylyListdata.value[1].id;
    yylyname.value = yylyListdata.value[1].name;
    yylyknowdelgelist.value = yylyListdata.value[1].knowledges;
    yylyimg_text.value = yylyListdata.value[1].knowledges[0];
  } else if (index == 2) {
    yylyName.value = "公共图书馆";
    yylytextcont.value = yylyListdata.value[2].description || '暂无简介';
    yylytid.value = yylyListdata.value[2].id;
    yylyname.value = yylyListdata.value[2].name;
    yylyknowdelgelist.value = yylyListdata.value[2].knowledges;
    yylyimg_text.value = yylyListdata.value[2].knowledges[0];
  } else if (index == 3) {
    yylyName.value = "高校图书馆";
    yylytextcont.value = yylyListdata.value[3].description || '暂无简介';
    yylytid.value = yylyListdata.value[3].id;
    yylyname.value = yylyListdata.value[3].name;
    yylyknowdelgelist.value = yylyListdata.value[3].knowledges;
    yylyimg_text.value = yylyListdata.value[3].knowledges[0];
  }
};
const getProvince = async () => {
  try {
    const res = await PostProvince();
    province.value = res.info;
  } catch (error) {
    console.log(error);
  }
};
const currentItem = computed(() => {
  return imgList.value[currentCarouselIndex.value] || null;
});
const getHydtList = async () => {
  const res = await getselectNotice({
    pageIndex: "1",
    pageSize: "4",
  });

  if (res.info) {
    hydtList.value = res.info.list;
    loading5.value = false;
  }
};

const handleMore = () => {
  router.push({
    name: "knowledge",
    query: { id: selectedNavKey.value },
  });
};

const getResourcerecommend = async (id) => {
  try {
    const response = await PostJPknowList({
      pageIndex: "1",
      pageSize: "10",
      contentCId: Number(id),
    });
    if (response.status == 200) {
      imgList.value = response.info;
    } else {
      console.log("接口返回的数据为空或格式不正确");
    }
  } catch (error) {
    console.error("获取数据失败:", error);
  }
};

const selectTab = async (item) => {
  // await getResourcerecommend(index + 1);
  tabactiveIndex.value = item.cid;
  getResourcerecommend(item.cid);
};
const handlenavinfo = async (item, index) => {
  // console.log(item, "ooo");
  activeNavIndex5.value = index;
  navtotalname.value = item.name;
  await getResourceContent(item.id);
  selectedNavKey.value = item.id;
  navindeximg.value = item.indexImg;
  console.log(navindeximg.value, "navindeximg");
};

const getResourceContent = async (id) => {
  try {
    const params = {
      pageIndex: "1",
      pageSize: "12",
      contentCId: id,
    };
    const response = await PostselectKnowledgeBaseList(params);
    if (response.info) {
      activeNav3.value = response.info.list.slice(2);
      activeNav4.value = response.info.list.slice(0, 2);
      tabactiveIndex1.value = activeNav4.value[0];
      tabactiveIndex2.value = activeNav4.value[1];
      totalnumber.value = response.info.total;
      // 确保即使数据不存在也有默认值
      activeNav5.value = {
        ...activeNav4.value[0],
        imgUrl: activeNav4.value[0]?.imgUrl || null,
      };

      activeNav6.value = {
        ...activeNav4.value[1],
        imgUrl: activeNav4.value[1]?.imgUrl || null,
      };
    }
    loading3.value = false;
  } catch (error) {
    console.error("获取数据失败:", error);
  }
};
const handleEvent = (data) => {
  LoginType.value = false;
};

const carouselItems = ref([banner1, banner2, banner3,banner5]);
const activeIndex = ref(0);
const carouselRef = ref(null);

const tablist = ref([
 {
  name:"红色党建",
  cid:'387'
 },  {
  name:"历史文化",
  cid:'386'
 },  {
  name:"一带一路",
  cid:'393'
 },  {
  name:"水利水电",
  cid:'385'
 },]);
const navlists = ref([]);

const getResourceNavi = async () => {
  try {
    const params = { type: "content" };
    const response = await fetchResourceNavi(params);
    if (response.info) {
      navlists.value = response.info;
      navindeximg.value = response.info[0].indexImg;;
      navtotalname.value = response.info[0].name;
      selectedNavKey.value =response.info[0].id;
      await getResourceContent(response.info[0].id);
    } else {
      console.log("接口返回的数据为空或格式不正确");
    }
  } catch (error) {
    console.error("获取数据失败:", error);
  }
};
const getZFBMKListNavi = async () => {
  try {
    const params = { type: "business" };
    const response = await fetchResourceNavi(params);
    if (response.info) {
      yylyListdata.value = response.info.slice(0, 5);
      yylyimg_text.value = yylyListdata.value[0].knowledges[0];
      loading4.value = false;
    } else {
      console.log("接口返回的数据为空或格式不正确");
    }
  } catch (error) {
    console.error("获取数据失败:", error);
  }
};

const numberIcons = [bd01, bd02, bd03, bd04, bd05, bd06, bd07];
const handleChange = (currentIndex) => {
  currentCarouselIndex.value = currentIndex;
};

const getKnowLegeAreaList = async () => {
  try {
    const response = await PostKnowledgeAreaList();
    if (response.info) {
      provinces.value = response.info;
    } else {
      console.log("接口返回的数据为空或格式不正确");
    }
  } catch (error) {
    console.error("获取数据失败:", error);
  }
};

const getYearMonth = (str) => {
  var year = str.substring(0, 4);
  var month = str.substring(5, 7);
  return year + "年" + month + "月";
};
const getNumberIcon = (index) => {
  return numberIcons[index] || numberIcons[0];
};
const getBuyKnowledgeBase = async () => {
  const res = await getBuyKnowledgeBaseList({ pageIndex: "1", pageSize: "7" });
  if (res?.info) {
    BuyKnowledgeBaseList.value = res.info.list;
    // loading2.value = false;
  }
};
const getImagePath2 = (filePath) => {
  const baseApi = process.env.VUE_APP_BASE_API;
  if (baseApi) {
    return process.env.VUE_APP_BASE_API + "/ckbop" + filePath;
  } else {
    return "/ckbop" + filePath;
  }
};

// 图片处理方法
const getImagePath = (url) => {
  if (!url) return defaultImg;

  try {
    if (/^https?:\/\//.test(url)) return url;

    const baseApi = process.env.VUE_APP_BASE_API;
    if (baseApi) {
      return baseApi + "/ckbop" + url.replace(/^\/?ckbop\//, "");
    } else {
      return "/ckbop" + url.replace(/^\/?ckbop\//, "");
    }
    // }

    // 情况4：本地assets目录图片
    return new URL(`../assets/${url}`, import.meta.url).href;
  } catch {
    // 任何错误都返回默认图片
    return defaultImg;
  }
};
// 轮播图切换时更新activeIndex
const handleCarouselChange = (currentIndex) => {
  activeIndex.value = currentIndex;
};

// 点击指示器切换轮播图
const handleIndicatorClick = (index) => {
  activeIndex.value = index;
  carouselRef.value.setActiveItem(index);
};

const handlelibiarry = async () => {
  try {
    const res = await getLibraryKnowledgeBaseList({
      pageSize: "4",
      pageIndex: "1",
    });
    if (res) {
      // LibraryKnowledList.value = res.info.slice(1);
      dataOpenList.value = res.info;
      // console.log(LibraryKnowledList.value,'999');

      fristzttsgdata.value = res.info[0];
    }
  } catch (error) {
    console.log(error);
  }
};

const getNewKnowledgeBase = async (id) => {
  loading.value = true;
  const res = await getNewKnowledgeBaseList({
    pageIndex: "1",
    pageSize: "10",
    contentCId: Number(id),
  });
  if (res?.info) {
    NewKnowledgeBaseList.value = res.info.list;
    currentCarouselIndex.value = 0;
    loading.value = false;
  }
};
const getImagePath3 = (filePath) => {
  if (!filePath) return ""; // 如果为空，返回空字符串避免错误

  const baseApi = process.env.VUE_APP_BASE_API || "";
  const finalUrl = baseApi + "/ckbop" + filePath;

  return finalUrl;
};
const handleLog = async () => {
  try {
    const res = await getBuyLog({
      type: "1",
      url: weburl.value,
      second: stayTime._value,
    });
    if (res) {
    }
  } catch (error) {
    console.log(error);
  }
};
const calculateLayout = () => {
   screenWidth.value = window.innerWidth
   const safeArea = 1400
  leftWidth.value = Math.max((screenWidth.value - safeArea) / 2 + 914, 914)
    rightWidth.value = Math.max(screenWidth.value - leftWidth.value, 516)
}

const postselectIndexKnowledgeDown = async()=>{
  const res = await getselectIndexKnowledgeDown({
   pageIndex:1,
   pageSize:10,
   type:'business'
  })
  yylyListdata.value = res.info.businessNavi
  provinces.value = res.info.knowledgeAreas
  province.value = res.info.province
  hydtList.value = res.info.notice
  hzjgdatalist.value = res.info.partner
  loading.value = false
}
const postgetselectIndexKnowledgeUp = async()=>{
    const res = await getselectIndexKnowledgeUp({
  pageIndex:1,
   pageSize:9,
   type:'content',
   contentCId:tabactiveIndex.value
    })
    if (res.info) {
      BuyKnowledgeBaseList.value = res.info.bangDan
      NewKnowledgeBaseList.value = res.info.newSx
      dataOpenList.value = res.info.library
      fristzttsgdata.value = res.info.library[0];
        imgList.value = res.info.jinpin;
  navlists.value = res.info.contentNavi;

   navindeximg.value = res.info.contentNavi[0].indexImg;;
      navtotalname.value = res.info.contentNavi[0].name;
      selectedNavKey.value =res.info.contentNavi[0].id;
      await getResourceContent(res.info.contentNavi[0].id);
    }


    loading.value = false;
     
}
onMounted(async () => {
   calculateLayout()
  window.addEventListener('resize', calculateLayout)
  await checkTokenStatus();
  // await handlelibiarry();
  // await getNewKnowledgeBase(1);
  // await getBuyKnowledgeBase();
  // await getKnowLegeAreaList();
  // await getResourceNavi();
  // await getResourcerecommend(387);
  // await getHydtList();
  // await gethzjgList();
  // await getProvince();
  // await getZFBMKListNavi();
  await postselectIndexKnowledgeDown();
  await postgetselectIndexKnowledgeUp();
  await handleyylyTab("", 0);
  // startAutoSwitch();
});
onUnmounted(async() => {
  if (autoSwitchTimer) clearInterval(autoSwitchTimer);
    await handleLog();

});
onBeforeUnmount(() => {
  window.removeEventListener('resize', calculateLayout)
})
</script>

<style scoped>
@import "./css.css";
</style>
